import {useEffect} from 'react';
import {Linking} from 'react-native';

import {createStorage} from '/util/async-storage';

export class DeepLinking {
  _url: any;

  constructor() {
    this._url = null;
  }

  openUrl = async (url: any) => {
    if (url) {
      // Define the list of server URLs and the custom app URL scheme
      const serverUrls = [
        'https://perf-v2.subprod-optavia.com/candidate/profile/',
        'https://qa5-backoffice.optavia.com/candidate/profile/',
        'https://optaviaconnect.com/candidate/profile/',
      ];
      const appUrlPrefix = 'optaviacoach://candidate/profile/';

      // Check if the URL starts with any of the server URLs
      const matchingServerUrl = serverUrls.find(serverUrl =>
        url.startsWith(serverUrl),
      );

      if (matchingServerUrl) {
        // If the URL matches a server URL, replace it with the app URL scheme
        const recordId = url.split('/').pop(); // Extract the record ID from the server URL
        const appUrl = `${appUrlPrefix}${recordId}`; // Create the app URL

        // Check if the app can open the URL scheme
        const supported = await Linking.canOpenURL(appUrl);
        if (supported) {
          await Linking.openURL(appUrl); // Open the custom deep link
        }
      } else {
        const supported = await Linking.canOpenURL(url);
        if (supported) {
          await Linking.openURL(url);
        }
      }
    }
  };
}

export const deepLinking = new DeepLinking();

export const {
  setValue: setUrl,
  getValue: getDeepLinkingUrlFromStorage,
  clearValue: clearDeepLinkUrl,
} = createStorage({
  key: 'deep-linking-url',
  defaultValue: null,
});
export const useClearDeeplinkingArtifacts = () => {
  useEffect(() => {
    clearDeepLinkUrl();
  }, []);
};
